import { cn } from "@/lib/utils";
import styles from "./liveagent-bubble-icon.module.css";

const LiveagentBubbleIcon: React.FC<
  React.SVGProps<SVGSVGElement> & { state: string }
> = ({ state = "static", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 44 44"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        {...props}
      >
        <path
          d="M12,29.5v2.5c0,.8841.3512,1.7319.9763,2.357s1.473.9763,2.357.9763h20L42,42v-26.6667c0-.884-.3512-1.7319-.9763-2.357s-1.473-.9763-2.357-.9763h-.8334-1.6666"
          fill="none"
          stroke="#f0eeee"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32,22c0,.8841-.3512,1.7319-.9763,2.357s-1.473.9763-2.357.9763h-20.00003L2,32L2,5.33333c0-.88405.35119-1.7319.97631-2.35702s1.47297-.97631,2.35702-.97631h23.33337c.884,0,1.7319.35119,2.357.97631s.9763,1.47297.9763,2.35702L32,22Z"
          fill="none"
          stroke="#fff"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          r="1.5"
          transform="translate(10.5 13.6666)"
          opacity="0"
          fill="#fff"
          className={cn(state === "loading" ? styles.dot1 : styles.showDot)}
        />
        <circle
          r="1.5"
          transform="translate(17.5 13.6666)"
          opacity="0"
          fill="#fff"
          className={cn(state === "loading" ? styles.dot2 : styles.showDot)}
        />
        <circle
          r="1.5"
          transform="translate(24.5 13.6666)"
          opacity="0"
          fill="#fff"
          className={cn(state === "loading" ? styles.dot3 : styles.showDot)}
        />
      </svg>
    </>
  );
};

export default LiveagentBubbleIcon;
